import { render, staticRenderFns } from "./JsrydjForm.vue?vue&type=template&id=63374656"
import script from "./JsrydjForm.vue?vue&type=script&lang=js"
export * from "./JsrydjForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports